import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import type { ChangeWheelsView } from "@slfinrtl/ui-bff-routes"
import { useEffect } from "react"
import type { UseFormReturn } from "react-hook-form"
import { useForm } from "react-hook-form"
import { getMarketLanguageTranslations } from "src/common/translations"
import type { ChangeCustomWheelsFormProps } from "src/hooks"

export const useChangeCustomWheelsForm = ({
	view,
}: {
	view: ChangeWheelsView["custom"]
}): UseFormReturn<ChangeCustomWheelsFormProps> => {
	const { availableLocales } = useDealerContext()
	const form = useForm<ChangeCustomWheelsFormProps>({
		defaultValues: {
			name: getMarketLanguageTranslations(availableLocales, {}),
			tags: [],
		},
	})

	useEffect(() => {
		form.reset(
			{
				name: getMarketLanguageTranslations(availableLocales, view.name),
				tags: view.tags.keys,
			},
			{ keepFieldsRef: true },
		)
	}, [view, availableLocales, form])

	return form
}
